module.exports = __webpack_public_path__ + "static/media/iconoon.09b2643e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/iconoon.eot?8pq8ff
// module id = 558
// module chunks = 2